import { createSelector } from 'reselect';
import * as constants from './itemGroups.constants';

export const getItemGroupsList = (state) => state.getIn([constants.ITEM_GROUPS, constants.LIST]);
export const getItemGroupsListFetchedFlag = (state) => state.getIn([constants.ITEM_GROUPS, constants.ITEM_GROUPS_LOADED]);
export const deactivateInProgressSelector = (state) => state.getIn([constants.ITEM_GROUPS, constants.DEACTIVATE_IN_PROGRESS]);

